export interface CustomConversionEventTotal {
  name: string;
  latest: number;
  total: number;
}

export const exampleCCEventTotal: CustomConversionEventTotal = {
  name: 'View Website',
  latest: 1622054656,
  total: 5,
};
